const SENTENCE_PATTERN = /[^.!?]+[.!?]+["”’']*\s*/g
const CLOSING_MARK_BY_OPENING: Record<string, string> = {'“': '”', '"': '"'}

export const truncateToSentences = (text: string, maxSentences: number): string => {
  const sentences = text.match(SENTENCE_PATTERN) ?? []
  const keptText = sentences.slice(0, maxSentences).join('')

  if (sentences.length === 0 || keptText.trim() === text.trim()) {
    return text
  }

  const truncated = keptText.trim()
  const closingMark = CLOSING_MARK_BY_OPENING[text[0]]

  return closingMark && !truncated.endsWith(closingMark) ? `${truncated}${closingMark}` : truncated
}
